import { Image } from '$components/basic/Image';
import { PreloadImage } from '$util/PreloadImage';
import { Title } from '@/components/atoms/Title';
import { Button, DesignType } from '@/components/atoms/Button';
import Styled from './styled';

const getAroundLogoSrc = '/partners/logo_getaround_pmsqr5.jpg';

export default function GoodDeals() {
  return (
    <Styled className="GoodDeals">
      <header>
        <Title h={3}>Good deals</Title>
        <p>
          Here you can find <strong>incredible deals</strong> with our beloved partners{' '}
          <span role="img" aria-label="celebrate">
            🎉
          </span>
        </p>
      </header>
      <article>
        <header>
          <PreloadImage provider="cloudinary" src={getAroundLogoSrc} width={147} />
          <Image
            provider="cloudinary"
            src={getAroundLogoSrc}
            alt="getaround logo"
            layout="fixed"
            width="147"
            height="33"
          />
          <div>
            <strong>Earn £50</strong> with Getaround!
          </div>
        </header>
        <div className="content">
          <p>
            Getaround lets you hire a car from among the thousands parked nearby, providing a simpler, quicker
            car rental service. If you have a vehicle, hire it out and let it pay its own way.
          </p>
          <ol>
            <li>Add your car on Getaround</li>
            <li>Rent out your car for the 1st time</li>
            <li>Get £50 voucher on Fixter!</li>
          </ol>
        </div>
        <footer>
          <Button
            designType={DesignType.CTA_DARK}
            size="L"
            href="https://uk.getaround.com/rent-your-car?utm_campaign=partnership&utm_source=fixter&utm_content=partner_page"
            target="_blank"
            rel="noreferrer"
            iconId="arrows/arrow-up-right"
          >
            Get deal
          </Button>
        </footer>
      </article>
    </Styled>
  );
}
